import React, { Component } from "react"
import styled from "styled-components"
import { connect } from "react-redux"
// import Select from 'react-select'
import Divider from "../divider"
// import Button from '../buttonLight'

import ReactTable from "react-table"
import "react-table/react-table.css"
import "../../style/react-table-custom.css"

// import { yearOptions, weekOptions } from '../graphCard/options'

// import { cohortExample } from './example'

// const SelectContainer =styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: flex-end;
// `

const Container = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  background: #fff;
  width: 100%;
  flex: 1;
  margin-bottom: 20px;
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;
`

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 20px 10px;
  flex: 1;
`
const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
`

const ContainerButton = styled.div`
  display: flex;
  gap: 10px;
`

const GraphContainer = styled.div`
  display: block;
  padding: 0px 20px;
  overflow-x: hidden;
  width: 100%;
`

const StyledButton = styled.button`
  background-color: #6e8ca0;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  outline: none;

  &:hover {
    background-color: #6e8ca0;
    outline: none;
    border: none;
  }
`

const ResetButton = styled.button`
  background-color: #6e8ca0;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  outline: none;

  &:hover {
    background-color: #6e8ca0;
    outline: none;
    border: none;
  }
`

// React-Select Style Section
// const customStylesYear = {
//   container: (styles) => ({
//     ...styles,
//     width: 250,
//   }),
// }

// const customStylesWeek = {
//   container: (styles) => ({
//     ...styles,
//     width: 250,
//     marginTop: "5px",
//   }),
// }

class GraphCohortCard extends Component {
  state = {
    year: null,
    week: null,
    data: this.props.dataRetentionList,
    numCols: 25,
  }

  componentDidMount() {
    this.props.FaceserRetention(this.state.numCols)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.numCols !== this.state.numCols) {
      this.props.FaceserRetention(this.state.numCols)
    }
  }

  handleChange = (selectedOption, key) => {
    this.setState({ [key]: selectedOption })
  }

  addColumns = () => {
    this.setState((prevState) => ({
      numCols: prevState.numCols + 12,
    }))
  }

  resetColumns = () => {
    this.setState({
      numCols: 25,
    })
  }

  render() {
    const {
      title,
      // data,
      // type , width ,height, gWidth, gHeight
    } = this.props

    const generateColumns = (numCols) => {
      const columns = [
        {
          Header: () => <h6>{""}</h6>,
          accessor: "date",
          minWidth: 70,
          Cell: ({ value }) => <div style={{ fontWeight: "400" }}>{value}</div>,
        },
      ]

      for (let i = 0; i < numCols; i++) {
        const col = numCols - i
        columns.push({
          Header: () => <h6>{i}</h6>,
          accessor: `col${i + 1}`,
          minWidth: 65,
          Cell: ({ value, row }) => (
            <div
              style={{
                color: col === row._index + 1 ? "#D3D3D3" : "",
                fontWeight: col === row._index + 1 ? "400" : "400",
                fontStyle: col === row._index + 1 ? "italic" : "normal",
              }}>
              {value}
            </div>
          ),
        })
      }

      return columns
    }

    const allColumns = generateColumns(this.state.numCols)
    return (
      <Container>
        <HeaderContainer>
          <HeaderContent>
            <h5>{title}</h5>
            <ContainerButton>
              {this.state.numCols > 25 && (
                <ResetButton onClick={this.resetColumns}>Reset</ResetButton>
              )}
              <StyledButton onClick={this.addColumns}>Load More</StyledButton>
            </ContainerButton>
          </HeaderContent>
          <Divider />
        </HeaderContainer>
        <GraphContainer>
          <ReactTable
            data={this.props.dataRetentionList}
            columns={allColumns}
            pageSize={this.props.dataRetentionList.length}
            showPagination={false}
            className="no-scroll-table"
          />
        </GraphContainer>
      </Container>
    )
  }
}

const mapState = (state) => {
  return {
    dataRetentionList: state.dashoard.dataRetentionList,
  }
}

const mapDispatch = (dispatch) => {
  return {
    FaceserRetention: (numCols) => dispatch.dashoard.FaceserRetention(numCols),
  }
}

export default connect(mapState, mapDispatch)(GraphCohortCard)
